'use client';
import { FanProfileUser, IFanProfileUser } from './fan-profile-user/fan-profile-user';
import { FanProfileBadges, IFanProfileBadges } from './fan-profile-badges';
import { IWhitelabelConfig } from '../user/creator-details.typings';
import { IFanConversationSet } from '../conversation';

interface IFanProfileProps {
  user: IFanProfileUser;
  badges: IFanProfileBadges;
  creatorsData?: {
    creators: any;
    isCreatorSuccess: boolean;
  };
  fetchCreatorProfile?: (creatorId: string) => Promise<any>;
  whitelabelConfig?: IWhitelabelConfig;
  currentCommunityCreatorId: string;
  groupChats: IFanConversationSet[];
}
export function FanProfile({
  user,
  badges,
  creatorsData,
  fetchCreatorProfile,
  whitelabelConfig,
  currentCommunityCreatorId,
  groupChats,
}: IFanProfileProps) {
  return (
    <div className="relative flex flex-1 flex-col gap-0 pb-16 lg:flex-row lg:gap-8 xl:gap-16">
      <FanProfileUser
        {...user}
        whitelabelConfig={whitelabelConfig}
        currentCommunityCreatorId={currentCommunityCreatorId}
        groupChats={groupChats}
      />
      <FanProfileBadges
        {...badges}
        creatorsData={creatorsData}
        fetchCreatorProfile={fetchCreatorProfile}
        whitelabelConfig={whitelabelConfig}
      />
    </div>
  );
}
